import { useQuery } from "@tanstack/react-query";

import { dutySchedulesApi } from "@/api";
import { QueryKey } from "@/query/Query";

// Live configuration, not plan data: it answers who may take on a duty now. The table itself renders
// the user codes snapshotted at calculation time, so somebody missing here still shows in the plan.
export function useDutyScheduleCounselorOptions() {
  const { data: counselors, isLoading } = useQuery({
    queryKey: [QueryKey.DutyScheduleCounselorOptions],
    queryFn: () => dutySchedulesApi.getDutyScheduleCounselorOptions(),
  });

  return { counselors: counselors ?? [], isLoading };
}
